<b-container fluid="sm">
    <b-row class="pt-3">
        <b-col>
            <legend>Flexi Pay Balance</legend>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="6">
            <b-row>
                <b-col><strong>Balance :</strong></b-col>
                <b-col md="8">R{{flexiPay.balance}}</b-col>
            </b-row>
        </b-col>
    </b-row>
    <b-row>
        <b-col class="pt-1" sm="12" md="3" ><b-button @click="PayOut(0)" block variant="primary">Credit Umbai Wallet</b-button> </b-col>
        <b-col class="pt-1" sm="12" md="3"><b-button @click="PayOut(1)" block block variant="outline-dark">Cash Out</b-button></b-col>
        <b-col class="pt-1" sm="12" md="3">
            <router-link
                :to='{
                  path: "/flexipayhistory",
                  query: {
                    w: flexiPay.id
                  },
                }'
              >
            <b-button block variant="outline-dark">View All Transactions</b-button>
        </router-link>
    </b-col>
    </b-row>
</b-container>